import {MonthPagination, MonthPaginationProps} from "./MonthPagination";
import React, {FC} from "react";
import {ToggleButton, ToggleButtonGroup} from "@material-ui/lab";
import {Close, EventAvailable, EventBusy} from "@material-ui/icons";
import {Divider, IconButton, InputAdornment, TextField} from "@material-ui/core";
import {MonthDaysHeader} from "./MonthDaysHeader";

export type SelectionMode = 'busy' | 'idle' | 'busy-idle'

interface WorkersCalendarHeaderProps {
    pagination: MonthPaginationProps;
    search: {
        searchString: string;
        onChange: (val: string) => void;
    },
    selection: {
        selectionMode: 'busy' | 'idle' | 'busy-idle'
        setSelectionMode: (v: SelectionMode) => void;
    }
    amountOfDays: number;
}

const transformSelection = (v: SelectionMode): ('y' | 'n') [] => {
    switch (v) {
        case "busy-idle":
            return ['y', 'n'];
        case "busy":
            return ['y'];
        case "idle":
            return ['n']
    }
}

const getTitle = (v: SelectionMode) => {
    switch (v) {
        case "busy-idle":
            return 'Alle Mitarbeiter werden gezeigt';
        case "idle":
            return "Mitarbeiter ohne Termin werden gezeigt";
        case "busy":
            return "Mitarbeiter mit Termin werden gezeigt";
    }
}

export const WorkersCalendarHeader: FC<WorkersCalendarHeaderProps> = (props) => {

    const handleWorkerSelectMode = (event: React.MouseEvent<HTMLElement>, newValues: ('y' | 'n') []) => {
        if (newValues.length) {
            const includesY = newValues.includes('y');
            const includesN = newValues.includes('n');
            if (includesY && includesN) {
                props.selection.setSelectionMode('busy-idle')
            } else if (includesY) {
                props.selection.setSelectionMode('busy')
            } else if (includesN) {
                props.selection.setSelectionMode('idle')
            }
        }
    };

    return (
        <React.Fragment>
            <div style={{display: 'flex', justifyContent: "space-between", alignItems: 'center', marginBottom: 16}}>
                <ToggleButtonGroup
                    title={getTitle(props.selection.selectionMode)}
                    size="small"
                    value={transformSelection(props.selection.selectionMode)}
                    onChange={handleWorkerSelectMode}
                    style={{paddingLeft: 180}}
                >
                    <ToggleButton value="y">
                        <EventAvailable fontSize="small"/>
                    </ToggleButton>
                    <ToggleButton value="n">
                        <EventBusy fontSize="small"/>
                    </ToggleButton>
                </ToggleButtonGroup>
                <MonthPagination
                    firstOfSelectedMonth={props.pagination.firstOfSelectedMonth}
                    onChange={props.pagination.onChange}
                />
            </div>
            <div style={{display: 'flex', marginBottom: 8, alignItems: "center"}}>
                <TextField
                    style={{width: 180, paddingRight: 24}} value={props.search.searchString}
                    onChange={(e) => props.search.onChange(e.target.value)}
                    placeholder="Schnellsuche"
                    onKeyDown={e => {
                        if (e.code === "Escape") {
                            props.search.onChange('');
                        }
                    }}
                    InputProps={{
                        endAdornment: props.search.searchString !== ''
                            ? (
                                <InputAdornment position={"end"}>
                                    <IconButton size="small" onClick={() => props.search.onChange('')}>
                                        <Close fontSize="small"/>
                                    </IconButton>
                                </InputAdornment>
                            )
                            : undefined
                    }}
                />
                <div style={{display: 'flex', justifyContent: "space-between", flex: 1}}>
                    <MonthDaysHeader
                        amountOfDays={props.amountOfDays}
                        firstOfSelectedMonth={props.pagination.firstOfSelectedMonth}
                    />
                </div>
            </div>
            <Divider/>
        </React.Fragment>
    )
}
